function createWorkFlowSteps(list) {
  return list.map((wfs) => {
    const obj = {
      name: wfs.name,
      stepEnabled: wfs.stepEnabled,
      selectedProduct: wfs.selected,
      labNotes: wfs.labNotes,
    };

    // Add custom step content
    if (wfs.customContent) obj.customContent = wfs.customContent;

    // add products
    obj.products = wfs.products
      ? wfs.products.map((product) => {
        if (product.customContent) return {key: product.key, customContent: product.customContent};
        return product.pimId;
      })
      : null;
    return obj;
  });
}

export function buildLsObjForBackend({
                                       id = '',
                                       title = '',
                                       steps = [],
                                       owner = '',
                                       analyte = '',
                                       application = '',
                                       startingMaterial = '',
                                       technology = '',
                                       activeStepTags = {},
                                       activeWorkflowTags = {},
                                       tagsPublicationId=''
                                     } = {}, publication_id) {
  return JSON.stringify({
    publication_id: publication_id ?? '',
    id: id ?? '',
    title,
    document: {
      owner,
      entryPoints: {
        analyte,
        application,
        startingMaterial,
        technology,
      },
      activeTags:{
        step:activeStepTags,
        workflow:activeWorkflowTags
      },
      workflow_steps: createWorkFlowSteps(steps),
      last_mod_date: new Date(),
      publication_id: tagsPublicationId,
    },
  });
}
